import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../Button';
import type { Arbeitsschritt } from './types';
import { OHNE_ABSCHNITT, abschnittVon } from './abschnittOrdnung';

interface SchrittZusammenfuehrLeisteProps {
  gewaehlt: Arbeitsschritt[];     // angehakte Zeilen in Listenreihenfolge
  zielId: string | null;
  gesperrt: boolean;              // „Weiter“ liest gerade die Zeilen
  onZiel: (id: string) => void;
  onWeiter: () => void;
  onAbbrechen: () => void;
}

/**
 * Leiste des Auswahlmodus „Zusammenführen“: Zeilen anhaken, ab zwei die
 * Zielzeile wählen (sie bleibt, die übrigen werden nach dem Speichern
 * gelöscht), dann weiter in den Bearbeiten-Dialog.
 */
export const SchrittZusammenfuehrLeiste: React.FC<SchrittZusammenfuehrLeisteProps> = ({
  gewaehlt, zielId, gesperrt, onZiel, onWeiter, onAbbrechen,
}) => (
  <div className="p-3 bg-blue-50 border-b border-blue-200 text-xs text-blue-900 space-y-2">
    <div>
      <strong>Arbeitsschritte zusammenführen</strong>
      <p className="mt-1 text-[11px] text-blue-800">
        {gewaehlt.length < 2
          ? 'Mindestens zwei Zeilen anhaken, die zu einer zusammengefasst werden sollen.'
          : `${gewaehlt.length} Zeilen gewählt. Die Zielzeile bleibt erhalten, die übrigen gehen in ihr auf.`}
      </p>
    </div>
    {gewaehlt.length >= 2 && (
      <fieldset className="space-y-0.5 max-h-48 overflow-y-auto">
        <legend className="text-[11px] font-semibold mb-1">Zielzeile wählen</legend>
        {gewaehlt.map(s => (
          <label key={s.id} className="flex items-start gap-2 rounded px-1.5 py-1 hover:bg-blue-100 cursor-pointer">
            <input
              type="radio"
              name="sigeplan-zusammenfuehren-ziel"
              className="mt-0.5 shrink-0"
              checked={s.id === zielId}
              disabled={gesperrt}
              onChange={() => onZiel(s.id)}
            />
            <span className="min-w-0">
              <span className="block truncate font-medium text-slate-800">{s.bezeichnung}</span>
              <span className="block truncate text-[10px] text-slate-500">
                {abschnittVon(s) || OHNE_ABSCHNITT}{s.gewerk ? ` · ${s.gewerk}` : ''}
              </span>
            </span>
          </label>
        ))}
      </fieldset>
    )}
    <div className="flex flex-wrap gap-2">
      <Button variant="primary" size="sm" onClick={onWeiter} disabled={gewaehlt.length < 2 || !zielId || gesperrt}>
        {gesperrt && <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" />}
        Weiter
      </Button>
      <Button variant="ghost" size="sm" onClick={onAbbrechen} disabled={gesperrt}>
        Abbrechen
      </Button>
    </div>
  </div>
);
